import { incYenOf, incOf } from '../lib/pricing';
export const courseOverview = {
  name: 'マスターコース',
  nameEn: 'MASTER COURSE',
  duration: '3ヶ月',
  days: '16日間',
  totalHours: '96時間',
  price: incYenOf('ac-master'),
  schedule: '2〜4月・9〜11月開校',
  classFormat: '土日開催・1日6時間（90分×4コマ）',
  capacity: '完全少人数制（定員6名）',
  target: 'プロ志望者・管理職を目指す方',
};

export const trustBadges = [
  {
    icon: 'ri-vip-crown-line',
    text: '最上級課程・96時間',
  },
  {
    icon: 'ri-user-star-line',
    text: '専門家マスタークラス2回',
  },
  {
    icon: 'ri-award-line',
    text: '認定マスターバトラー授与',
  },
  {
    icon: 'ri-checkbox-circle-line',
    text: 'エッセンシャル・アドバンスの全内容を含みます',
  },
];

export const targetAudienceItems = [
  {
    icon: 'ri-briefcase-line',
    text: '執事として就業・独立を本気で目指す方',
  },
  {
    icon: 'ri-building-2-line',
    text: 'ホテル・レジデンスでバトラー部門の責任者を目指す方',
  },
  {
    icon: 'ri-vip-diamond-line',
    text: '富裕層対応の総責任者として現職の価値を高めたい方',
  },
  {
    icon: 'ri-global-line',
    text: '海外水準の教育を離職せず国内で修めたい方',
  },
];

export const learningContents = [
  {
    id: 'household-management',
    title: '執事としての管理能力',
    titleEn: 'Household Management',
    description: '家政全体の年間計画立案から、予算と物品の管理、外部業者との折衝まで、ハウスホールドマネジメントの実務を体系的に学びます。補助スタッフの配置計画や品質管理の仕組みづくりまで、管理職としての視座を養います。',
    icon: 'ri-dashboard-line',
    imageSeq: 'master-household',
  },
  {
    id: 'crisis-security',
    title: '危機対応とセキュリティ',
    titleEn: 'Crisis & Security',
    description: '急病・事故・不審者対応などの初動判断と、主およびゲストを守る安全管理の考え方を演習形式で学びます。実際の邸宅や施設を想定したシナリオ演習を通じて、冷静かつ的確な判断力を養います。',
    icon: 'ri-shield-line',
    imageSeq: 'master-crisis',
  },
  {
    id: 'protocol',
    title: '国際的なプロトコル',
    titleEn: 'International Protocol',
    description: '公式行事における席次・国旗・贈答の作法など、国際儀礼の基礎を習得します。実在の国際行事をケーススタディとして分析し、どのような場面でも適切な対応ができる判断基準を身につけます。',
    icon: 'ri-flag-line',
    imageSeq: 'master-protocol',
  },
  {
    id: 'vip-service',
    title: 'VIPへの対応',
    titleEn: 'VIP Service',
    description: '著名人・要人の接遇において必須となる守秘義務、動線設計、先回りの準備といった高度なサービスの実践手法を学びます。過去の具体的な事例から、期待を超えるおもてなしの在り方を考察します。',
    icon: 'ri-star-line',
    imageSeq: 'master-vip',
  },
  {
    id: 'special-situations',
    title: '特殊状況への対処法',
    titleEn: 'Special Situations',
    description: '想定外の要望や突発的なトラブルに対する判断基準と、複数の代替案を組み立てる思考法を習得します。実際に起きうる難易度の高いシチュエーションを題材に、現場で通用する実践的な問題解決力を養います。',
    icon: 'ri-lightbulb-line',
    imageSeq: 'master-situations',
  },
  {
    id: 'leadership',
    title: 'リーダーシップスキル',
    titleEn: 'Leadership Skills',
    description: '補助スタッフへの適切な指示と育成、チームで品質を保つ仕組みづくりなど、執事長としてのリーダーシップを学びます。講師自身の管理経験に基づく実践的なケーススタディを通じて、人を動かす力を養います。',
    icon: 'ri-team-line',
    imageSeq: 'master-leadership',
  },
];

export const masterPrograms = [
  {
    icon: 'ri-user-star-line',
    title: '外部専門家マスタークラス',
    titleEn: 'Expert Masterclass',
    details: 'ソムリエ、危機管理、国際儀礼等の第一線で活躍する専門家を招いた特別講義を2回開催。現場でしか得られない知見を直接学べる貴重な機会です。',
    note: '※講師は開校に向けて順次公開予定',
  },
  {
    icon: 'ri-hotel-bed-line',
    title: '本物のサービスを体験する特別実習＋総合実技演習',
    titleEn: 'Real Service Experience & Practical Exam',
    details: '一流ホテルやレストランで提供される本格的なサービスを、受講生がゲスト（お客様）として体験し、プロの所作・間合い・気配りを間近で観察して学びます。受け手の立場を知ることは、質の高いサービスを提供するうえで欠かせません。また最終日には、アカデミー内でこれまで学んだすべての技能を統合した総合実技演習を行います。これが修了実技試験を兼ね、学びの集大成となります。',
    note: '※体験先は内容に応じてご案内します',
  },
  {
    icon: 'ri-chat-3-line',
    title: '個別キャリアコーチング',
    titleEn: 'Career Coaching',
    details: '講師との1対1面談を2回実施し、修了後の進路を一緒に設計します。進路に関するご相談・情報提供、独立開業のアドバイス、海外修行の情報提供など、あなたの目標に合わせた具体的なキャリアプランをお描きします。',
    note: '※面談日程はコース期間内に調整',
  },
  {
    icon: 'ri-t-shirt-2-line',
    title: 'オーダーメイドベスト',
    titleEn: 'Tailored Vest',
    details: '開校時に採寸を行い、コース中盤からご自身のベストを着用して学びます。制服を単なる衣服ではなく教育の一部と捉え、プロフェッショナルとしての自覚と誇りを身につけていただく本学院独自のプログラムです。',
    note: '※採寸は開講初日に実施',
  },
];

export const dailySchedule = [
  { time: '10:00 – 11:30', title: '理論講義', description: '管理論・危機対応・国際プロトコルなど、マスター課程にふさわしい高度な座学。実務経験豊富な講師がケーススタディを交えて講義します。' },
  { time: '11:45 – 13:15', title: '実技演習', description: '高度なサービス技術の実践。VIP対応やフォーマル行事のシミュレーションを、受講生お一人ずつ丁寧に指導します。' },
  { time: '13:15 – 14:00', title: '昼食休憩', description: '' },
  { time: '14:00 – 15:30', title: 'リーダーシップ演習', description: 'チーム指揮・指示出し・育成手法をロールプレイングで実践。管理職としての判断力と指導力を養います。' },
  { time: '15:45 – 17:15', title: '統合演習＋講評', description: '複数の技能を組み合わせた総合演習。講師による詳細なフィードバックと個別面談であなたの強みと課題を明確にします。' },
];

export const certificationInfo = {
  title: '修了実技試験と認定資格',
  titleEn: 'Certification Exam',
  description: 'コース最終日に実施する総合実技演習（これまで学んだ全技能を統合した実演）と筆記試験に合格すると、本学院最高位の認定資格が授与されます。',
  qualification: '認定マスターバトラー（Certified Master Butler）',
  badge: '認定ピンバッジ',
  note: '※当資格は一般社団法人全日本執事協会が独自に認定する民間資格です。',
};

export const courseBenefits = [
  {
    icon: 'ri-t-shirt-2-line',
    title: 'オーダーメイドベスト',
    description: '開校時に採寸し、あなただけのベストを仕立てます。コース中盤から着用し、プロフェッショナルとしての自覚を高めます。',
  },
  {
    icon: 'ri-book-open-line',
    title: '全教科書セット（全15冊・E1〜E5+A1〜A5+M1〜M5）',
    description: 'E群・A群に加え、国際プロトコル・危機管理・VVIPサービスなどM群5冊を含む全15冊を進呈。',
  },
  {
    icon: 'ri-vip-diamond-line',
    title: '高級懐中時計',
    description: '執事の象徴として、本学院オリジナルの懐中時計を進呈。修了後もプロフェッショナルとしての誇りを携えていただくための品です。',
  },
  {
    icon: 'ri-goblet-line',
    title: 'ワインオープナーセット',
    description: 'ソムリエナイフとウェイターズコークスクリューをセットで進呈。実習および修了後もご使用いただけます。',
  },
  {
    icon: 'ri-tools-line',
    title: '基本的な執事道具セット',
    description: 'プロ仕様の基本ツール一式を進呈します。',
  },
  {
    icon: 'ri-hand-sanitizer-line',
    title: '白手袋・オリジナルエプロン',
    description: '初日支給。実習時に着用するアカデミー特製エプロンと高品質な白手袋です。',
  },
];

export const nextStep = {
  title: '編入優遇制度',
  description: 'マスターコースはアドバンスの内容を含むため、アドバンスコース修了者が本コースへ進む場合、重複する内容分の受講料180,000円が減額されます。二つの課程を経て、揺るぎないプロフェッショナルへと成長されることを期待しています。',
  discountAmount: '180,000',
};

export const admissionSteps = [
  {
    step: '01',
    title: '資料請求',
    titleEn: 'Brochure',
    description: 'まずは資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお送りします。',
    icon: 'ri-file-text-line',
    href: '/brochure',
  },
  {
    step: '02',
    title: '個別相談（推奨）',
    titleEn: 'Consultation',
    description: '高額講座のため、個別相談を推奨しています。経験豊富なスタッフが、あなたの目標やご経験に合わせた最適な進路を提案します。',
    icon: 'ri-chat-3-line',
    href: '/consultation',
  },
  {
    step: '03',
    title: 'お申込み',
    titleEn: 'Apply',
    description: 'コースが決まりましたら、所定の申込フォームよりお手続きください。定員になり次第締切となります。',
    icon: 'ri-edit-line',
    href: '/apply',
  },
  {
    step: '04',
    title: '受講確定',
    titleEn: 'Confirmation',
    description: 'お申込み受付後、受講確定のご案内と事前準備資料をお送りします。開講初日には採寸も行います。',
    icon: 'ri-check-line',
    href: '#',
  },
];

export const relatedPages = [
  {
    title: 'エッセンシャルコース',
    description: '基礎から始める入門課程',
    href: '/courses/essential',
  },
  {
    title: 'アドバンスコース',
    description: '専門技能を磨く中級課程',
    href: '/courses/advanced',
  },
  {
    title: 'コース比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses/comparison',
  },
  {
    title: '年間スケジュール',
    description: '開校時期と授業日程のご案内',
    href: '/schedule',
  },
  {
    title: '料金詳細',
    description: '受講料に含まれるものの内訳',
    href: '/pricing/details',
  },
  {
    title: 'カリキュラム',
    description: '学ぶ内容の全体像を確認',
    href: '/curriculum',
  },
];

export const faqItems = [
  {
    question: '未経験でも直接マスターコースに申し込めますか？',
    answer: 'はい、お申込みいただけます。本コースはエッセンシャル・アドバンスの内容を含む統合課程のため、未経験の方も基礎から順に学べます。最適な学び方は個別相談でもご提案いたします。',
  },
  {
    question: '総合実技演習とは何ですか？',
    answer: 'アカデミー内で、これまで学んだ全技能を統合した総合実技演習です。これが修了実技試験を兼ね、合格者に「認定マスターバトラー」を授与します。',
  },
  {
    question: '支払い方法を教えてください。',
    answer: '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
  },
];